import formSponsors from './formSponsors';

export default {
  title: 'Sponsors Customization',
  attributeName: 'sponsors',
  createURL: 'sponsors',
  sessionParams: [],
  getURL: 'sponsors',
  updateURL: 'sponsors',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formSponsors,
  ],
  
};
